export function fields() {
	return [
		{
			type: "Input",
			title: "Input",
			options: {
				name: "",
				description: "",
				required: false
			}
		},
		{
			type: "Eposta",
			title: "E-posta",
			options: {
				name: "",
				description: "",
				required: false
			}
		},
		{
			type: "Textarea",
			title: "Textarea",
			options: {
				name: "",
				description: "",
				required: false
			}
		},
		{
			type: "Checkbox",
			title: "Checkbox",
			options: {
				name: "",
				content: "",
				description: "",
				required: false
			}
		}
	];
}